export default "__VITE_ASSET__DrCvwc8f__"